import React, { Component } from "react";
import { connect } from "react-redux";
import Table from '@mawesi-sas/mws_react_component_table';

class Usuarios extends Component {
  render() {
    return (
      <Table
        reducer="cencos"
        table={`modalCreate.data.tables.users`}
        showResumeFooter={false}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    modalCreateTipoProducto: state.tiposervicios.get("modalCreateTipoProducto")
  };
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Usuarios);
